import { FC } from 'react'
import { Column } from '@material-table/core'
import { Theme, useTheme } from '@material-ui/core'

import { getModuleNameFromProfileId, getModuleIdFromProfileId } from '../../ModuleNames'
import { msToDuration } from '../../Reporting'

import { LLModuleProfile } from '../../interfaces/ModuleTypes'

import { TableView } from '../dataview'

type Props = {
    labs: LLModuleProfile[]
}

type LearningProgressData = {
    id: string
    moduleId: string
    moduleName: string
    timeElapsed: string
    complete: number
}

const LearningProgress: FC<Props> = ({ labs }: Props) => {
    const theme = useTheme()
    const columns: Array<Column<LearningProgressData>> = getColumns(theme)

    const data: LearningProgressData[] = labs.map((lab, index) => ({
        id: 'lp' + index.toString(),
        moduleId: getModuleIdFromProfileId(lab.profileId),
        moduleName: getModuleNameFromProfileId(lab.profileId),
        timeElapsed: msToDuration(lab.profile['module-total-training-time']),
        complete: Math.round(lab.profile['module-score'])
    } as LearningProgressData
    ))

    return <TableView title={'Learning Labs'} data={data} columns={columns} />
}
export default LearningProgress

const getColumns = (theme: Theme): Column<LearningProgressData>[] => {
    return [
        {
            field: 'id',
            hidden: true,
        },
        {
            field: 'moduleId',
            hidden: true,
        },
        {
            field: 'moduleName',
            cellStyle: {
                fontSize: theme.typography.body1.fontSize,
            },
            defaultSort: 'asc',
        },
        {
            title: 'Time Elapsed',
            field: 'timeElapsed',
            type: 'numeric',
        },
        {
            title: 'Complete',
            field: 'complete',
            type: 'numeric',
            render: (rowData) => rowData.complete + '%'
        }
    ]
}